import { createSelector } from 'reselect';
import { isAnonymousSelector } from 'selectors/auth/isAnonymousSelector';
import { showSelector } from 'selectors/testTarget/offers/atbCarouselsHomepage/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showAtbCarouselsHomepageSelector = createSelector(
    isTestTargetReadySelector,
    showSelector,
    isAnonymousSelector,
    (testReady, show, isAnonymous) => testReady && show && !isAnonymous
);

export { showAtbCarouselsHomepageSelector };
